function refreshTabs() {
  const urlParams = new URLSearchParams(window.location.search)
  const activeTabId = urlParams.get('tab') || 'sessions'
  const activeFilterId =
    urlParams.get('PROPERTY_PROGRESS_TRACK_TITLE') || 'all'

  const activeTab = $(`[data-tab-id='${activeTabId}']`)

  const current = $(activeTab)
  const siblings = current.parents('.switcher').find('.tab')

  siblings.removeClass('tab_active')
  current.addClass('tab_active')

  const selectElem = $('.js-onload-cards-select').find(
    `[data-filter-id='${activeFilterId}']`
  )

  $('.js-onload-cards-select')
    .find('.select-head')
    .text(selectElem.text())
}

$(window).on('load', () => {
  if (!window.location.pathname.includes('session-seminars.html'))
    return

  refreshTabs()
})

$('.js-onload-cards-select').on('click', '.select-item', function () {
  const filterId = $(this).data('filter-id')
  const url = new URL(window.location.href)
  const tab = url.searchParams.get('tab')

  const params = []
  url.searchParams.forEach((_, key) => {
    params.push(key)
  })

  params.forEach((val) => {
    url.searchParams.delete(val)
  })

  if (tab) {
    url.searchParams.append('tab', tab)
  }

  url.searchParams.append('PROPERTY_PROGRESS_TRACK_TITLE', filterId)

  window.location.href = url
})
